export const TOUR_TARGETS = {
  STUDIO_TABS: '[data-tour="studio-tabs"]',
  SOURCE_UPLOAD: '[data-tour="source-upload"]',
  PROMPT_AREA: '[data-tour="prompt-area"]',
  ENHANCE_PROMPT_BUTTON: '[data-tour="enhance-prompt-button"]',
  GENERATION_BAR: '[data-tour="generation-bar"]',
  GENERATE_BUTTON: '[data-tour="generate-button"]',
  CREATIONS_GALLERY: '[data-tour="creations-gallery"]',
} as const;

export const TOUR_START_DELAY_MS = 800;
